// Country data stored directly in the component
  const countryData = [
    { name: "Afghanistan", flag: "🇦🇫", phoneCode: "+93" },
    { name: "Albania", flag: "🇦🇱", phoneCode: "+355" },
    { name: "Algeria", flag: "🇩🇿", phoneCode: "+213" },
    { name: "Andorra", flag: "🇦🇩", phoneCode: "+376" },
    { name: "Angola", flag: "🇦🇴", phoneCode: "+244" },
    { name: "Antigua and Barbuda", flag: "🇦🇬", phoneCode: "+1-268" },
    { name: "Argentina", flag: "🇦🇷", phoneCode: "+54" },
    { name: "Armenia", flag: "🇦🇲", phoneCode: "+374" },
    { name: "Australia", flag: "🇦🇺", phoneCode: "+61" },
    { name: "Austria", flag: "🇦🇹", phoneCode: "+43" },
    { name: "Azerbaijan", flag: "🇦🇿", phoneCode: "+994" },
    { name: "Bahamas", flag: "🇧🇸", phoneCode: "+1-242" },
    { name: "Bahrain", flag: "🇧🇭", phoneCode: "+973" },
    { name: "Bangladesh", flag: "🇧🇩", phoneCode: "+880" },
    { name: "Barbados", flag: "🇧🇧", phoneCode: "+1-246" },
    { name: "Belarus", flag: "🇧🇾", phoneCode: "+375" },
    { name: "Belgium", flag: "🇧🇪", phoneCode: "+32" },
    { name: "Belize", flag: "🇧🇿", phoneCode: "+501" },
    { name: "Benin", flag: "🇧🇯", phoneCode: "+229" },
    { name: "Bhutan", flag: "🇧🇹", phoneCode: "+975" },
    { name: "Bolivia", flag: "🇧🇴", phoneCode: "+591" },
    { name: "Bosnia and Herzegovina", flag: "🇧🇦", phoneCode: "+387" },
    { name: "Botswana", flag: "🇧🇼", phoneCode: "+267" },
    { name: "Brazil", flag: "🇧🇷", phoneCode: "+55" },
    { name: "Brunei", flag: "🇧🇳", phoneCode: "+673" },
    { name: "Bulgaria", flag: "🇧🇬", phoneCode: "+359" },
    { name: "Burkina Faso", flag: "🇧🇫", phoneCode: "+226" },
    { name: "Burundi", flag: "🇧🇮", phoneCode: "+257" },
    { name: "Cambodia", flag: "🇰🇭", phoneCode: "+855" },
    { name: "Cameroon", flag: "🇨🇲", phoneCode: "+237" },
    { name: "Canada", flag: "🇨🇦", phoneCode: "+1" },
    { name: "Cape Verde", flag: "🇨🇻", phoneCode: "+238" },
    { name: "Central African Republic", flag: "🇨🇫", phoneCode: "+236" },
    { name: "Chad", flag: "🇹🇩", phoneCode: "+235" },
    { name: "Chile", flag: "🇨🇱", phoneCode: "+56" },
    { name: "China", flag: "🇨🇳", phoneCode: "+86" },
    { name: "Colombia", flag: "🇨🇴", phoneCode: "+57" },
    { name: "Comoros", flag: "🇰🇲", phoneCode: "+269" },
    { name: "Congo", flag: "🇨🇬", phoneCode: "+242" },
    { name: "Costa Rica", flag: "🇨🇷", phoneCode: "+506" },
    { name: "Croatia", flag: "🇭🇷", phoneCode: "+385" },
    { name: "Cuba", flag: "🇨🇺", phoneCode: "+53" },
    { name: "Cyprus", flag: "🇨🇾", phoneCode: "+357" },
    { name: "Czech Republic", flag: "🇨🇿", phoneCode: "+420" },
    { name: "Denmark", flag: "🇩🇰", phoneCode: "+45" },
    { name: "Djibouti", flag: "🇩🇯", phoneCode: "+253" },
    { name: "Dominica", flag: "🇩🇲", phoneCode: "+1-767" },
    { name: "Dominican Republic", flag: "🇩🇴", phoneCode: "+1-809" },
    { name: "East Timor", flag: "🇹🇱", phoneCode: "+670" },
    { name: "Ecuador", flag: "🇪🇨", phoneCode: "+593" },
    { name: "Egypt", flag: "🇪🇬", phoneCode: "+20" },
    { name: "El Salvador", flag: "🇸🇻", phoneCode: "+503" },
    { name: "Equatorial Guinea", flag: "🇬🇶", phoneCode: "+240" },
    { name: "Eritrea", flag: "🇪🇷", phoneCode: "+291" },
    { name: "Estonia", flag: "🇪🇪", phoneCode: "+372" },
    { name: "Eswatini", flag: "🇸🇿", phoneCode: "+268" },
    { name: "Ethiopia", flag: "🇪🇹", phoneCode: "+251" },
    { name: "Fiji", flag: "🇫🇯", phoneCode: "+679" },
    { name: "Finland", flag: "🇫🇮", phoneCode: "+358" },
    { name: "France", flag: "🇫🇷", phoneCode: "+33" },
    { name: "Gabon", flag: "🇬🇦", phoneCode: "+241" },
    { name: "Gambia", flag: "🇬🇲", phoneCode: "+220" },
    { name: "Georgia", flag: "🇬🇪", phoneCode: "+995" },
    { name: "Germany", flag: "🇩🇪", phoneCode: "+49" },
    { name: "Ghana", flag: "🇬🇭", phoneCode: "+233" },
    { name: "Greece", flag: "🇬🇷", phoneCode: "+30" },
    { name: "Grenada", flag: "🇬🇩", phoneCode: "+1-473" },
    { name: "Guatemala", flag: "🇬🇹", phoneCode: "+502" },
    { name: "Guinea", flag: "🇬🇳", phoneCode: "+224" },
    { name: "Guinea-Bissau", flag: "🇬🇼", phoneCode: "+245" },
    { name: "Guyana", flag: "🇬🇾", phoneCode: "+592" },
    { name: "Haiti", flag: "🇭🇹", phoneCode: "+509" },
    { name: "Honduras", flag: "🇭🇳", phoneCode: "+504" },
    { name: "Hungary", flag: "🇭🇺", phoneCode: "+36" },
    { name: "Iceland", flag: "🇮🇸", phoneCode: "+354" },
    { name: "India", flag: "🇮🇳", phoneCode: "+91" },
    { name: "Indonesia", flag: "🇮🇩", phoneCode: "+62" },
    { name: "Iran", flag: "🇮🇷", phoneCode: "+98" },
    { name: "Iraq", flag: "🇮🇶", phoneCode: "+964" },
    { name: "Ireland", flag: "🇮🇪", phoneCode: "+353" },
    { name: "Israel", flag: "🇮🇱", phoneCode: "+972" },
    { name: "Italy", flag: "🇮🇹", phoneCode: "+39" },
    { name: "Ivory Coast", flag: "🇨🇮", phoneCode: "+225" },
    { name: "Jamaica", flag: "🇯🇲", phoneCode: "+1-876" },
    { name: "Japan", flag: "🇯🇵", phoneCode: "+81" },
    { name: "Jordan", flag: "🇯🇴", phoneCode: "+962" },
    { name: "Kazakhstan", flag: "🇰🇿", phoneCode: "+7" },
    { name: "Kenya", flag: "🇰🇪", phoneCode: "+254" },
    { name: "Kiribati", flag: "🇰🇮", phoneCode: "+686" },
    { name: "Korea, North", flag: "🇰🇵", phoneCode: "+850" },
    { name: "Korea, South", flag: "🇰🇷", phoneCode: "+82" },
    { name: "Kosovo", flag: "🇽🇰", phoneCode: "+383" },
    { name: "Kuwait", flag: "🇰🇼", phoneCode: "+965" },
    { name: "Kyrgyzstan", flag: "🇰🇬", phoneCode: "+996" },
    { name: "Laos", flag: "🇱🇦", phoneCode: "+856" },
    { name: "Latvia", flag: "🇱🇻", phoneCode: "+371" },
    { name: "Lebanon", flag: "🇱🇧", phoneCode: "+961" },
    { name: "Lesotho", flag: "🇱🇸", phoneCode: "+266" },
    { name: "Liberia", flag: "🇱🇷", phoneCode: "+231" },
    { name: "Libya", flag: "🇱🇾", phoneCode: "+218" },
    { name: "Liechtenstein", flag: "🇱🇮", phoneCode: "+423" },
    { name: "Lithuania", flag: "🇱🇹", phoneCode: "+370" },
    { name: "Luxembourg", flag: "🇱🇺", phoneCode: "+352" },
    { name: "Madagascar", flag: "🇲🇬", phoneCode: "+261" },
    { name: "Malawi", flag: "🇲🇼", phoneCode: "+265" },
    { name: "Malaysia", flag: "🇲🇾", phoneCode: "+60" },
    { name: "Maldives", flag: "🇲🇻", phoneCode: "+960" },
    { name: "Mali", flag: "🇲🇱", phoneCode: "+223" },
    { name: "Malta", flag: "🇲🇹", phoneCode: "+356" },
    { name: "Marshall Islands", flag: "🇲🇭", phoneCode: "+692" },
    { name: "Mauritania", flag: "🇲🇷", phoneCode: "+222" },
    { name: "Mauritius", flag: "🇲🇺", phoneCode: "+230" },
    { name: "Mexico", flag: "🇲🇽", phoneCode: "+52" },
    { name: "Micronesia", flag: "🇫🇲", phoneCode: "+691" },
    { name: "Moldova", flag: "🇲🇩", phoneCode: "+373" },
    { name: "Monaco", flag: "🇲🇨", phoneCode: "+377" },
    { name: "Mongolia", flag: "🇲🇳", phoneCode: "+976" },
    { name: "Montenegro", flag: "🇲🇪", phoneCode: "+382" },
    { name: "Morocco", flag: "🇲🇦", phoneCode: "+212" },
    { name: "Mozambique", flag: "🇲🇿", phoneCode: "+258" },
    { name: "Myanmar", flag: "🇲🇲", phoneCode: "+95" },
    { name: "Namibia", flag: "🇳🇦", phoneCode: "+264" },
    { name: "Nauru", flag: "🇳🇷", phoneCode: "+674" },
    { name: "Nepal", flag: "🇳🇵", phoneCode: "+977" },
    { name: "Netherlands", flag: "🇳🇱", phoneCode: "+31" },
    { name: "New Zealand", flag: "🇳🇿", phoneCode: "+64" },
    { name: "Nicaragua", flag: "🇳🇮", phoneCode: "+505" },
    { name: "Niger", flag: "🇳🇪", phoneCode: "+227" },
    { name: "Nigeria", flag: "🇳🇬", phoneCode: "+234" },
    { name: "North Macedonia", flag: "🇲🇰", phoneCode: "+389" },
    { name: "Norway", flag: "🇳🇴", phoneCode: "+47" },
    { name: "Oman", flag: "🇴🇲", phoneCode: "+968" },
    { name: "Pakistan", flag: "🇵🇰", phoneCode: "+92" },
    { name: "Palau", flag: "🇵🇼", phoneCode: "+680" },
    { name: "Panama", flag: "🇵🇦", phoneCode: "+507" },
    { name: "Papua New Guinea", flag: "🇵🇬", phoneCode: "+675" },
    { name: "Paraguay", flag: "🇵🇾", phoneCode: "+595" },
    { name: "Peru", flag: "🇵🇪", phoneCode: "+51" },
    { name: "Philippines", flag: "🇵🇭", phoneCode: "+63" },
    { name: "Poland", flag: "🇵🇱", phoneCode: "+48" },
    { name: "Portugal", flag: "🇵🇹", phoneCode: "+351" },
    { name: "Qatar", flag: "🇶🇦", phoneCode: "+974" },
    { name: "Romania", flag: "🇷🇴", phoneCode: "+40" },
    { name: "Russia", flag: "🇷🇺", phoneCode: "+7" },
    { name: "Rwanda", flag: "🇷🇼", phoneCode: "+250" },
    { name: "Saint Kitts and Nevis", flag: "🇰🇳", phoneCode: "+1-869" },
    { name: "Saint Lucia", flag: "🇱🇨", phoneCode: "+1-758" },
    { name: "Saint Vincent and the Grenadines", flag: "🇻🇨", phoneCode: "+1-784" },
    { name: "Samoa", flag: "🇼🇸", phoneCode: "+685" },
    { name: "San Marino", flag: "🇸🇲", phoneCode: "+378" },
    { name: "Sao Tome and Principe", flag: "🇸🇹", phoneCode: "+239" },
    { name: "Saudi Arabia", flag: "🇸🇦", phoneCode: "+966" },
    { name: "Senegal", flag: "🇸🇳", phoneCode: "+221" },
    { name: "Serbia", flag: "🇷🇸", phoneCode: "+381" },
    { name: "Seychelles", flag: "🇸🇨", phoneCode: "+248" },
    { name: "Sierra Leone", flag: "🇸🇱", phoneCode: "+232" },
    { name: "Singapore", flag: "🇸🇬", phoneCode: "+65" },
    { name: "Slovakia", flag: "🇸🇰", phoneCode: "+421" },
    { name: "Slovenia", flag: "🇸🇮", phoneCode: "+386" },
    { name: "Solomon Islands", flag: "🇸🇧", phoneCode: "+677" },
    { name: "Somalia", flag: "🇸🇴", phoneCode: "+252" },
    { name: "South Africa", flag: "🇿🇦", phoneCode: "+27" },
    { name: "South Sudan", flag: "🇸🇸", phoneCode: "+211" },
    { name: "Spain", flag: "🇪🇸", phoneCode: "+34" },
    { name: "Sri Lanka", flag: "🇱🇰", phoneCode: "+94" },
    { name: "Sudan", flag: "🇸🇩", phoneCode: "+249" },
    { name: "Suriname", flag: "🇸🇷", phoneCode: "+597" },
    { name: "Sweden", flag: "🇸🇪", phoneCode: "+46" },
    { name: "Switzerland", flag: "🇨🇭", phoneCode: "+41" },
    { name: "Syria", flag: "🇸🇾", phoneCode: "+963" },
    { name: "Taiwan", flag: "🇹🇼", phoneCode: "+886" },
    { name: "Tajikistan", flag: "🇹🇯", phoneCode: "+992" },
    { name: "Tanzania", flag: "🇹🇿", phoneCode: "+255" },
    { name: "Thailand", flag: "🇹🇭", phoneCode: "+66" },
    { name: "Togo", flag: "🇹🇬", phoneCode: "+228" },
    { name: "Tonga", flag: "🇹🇴", phoneCode: "+676" },
    { name: "Trinidad and Tobago", flag: "🇹🇹", phoneCode: "+1-868" },
    { name: "Tunisia", flag: "🇹🇳", phoneCode: "+216" },
    { name: "Turkey", flag: "🇹🇷", phoneCode: "+90" },
    { name: "Turkmenistan", flag: "🇹🇲", phoneCode: "+993" },
    { name: "Tuvalu", flag: "🇹🇻", phoneCode: "+688" },
    { name: "Uganda", flag: "🇺🇬", phoneCode: "+256" },
    { name: "Ukraine", flag: "🇺🇦", phoneCode: "+380" },
    { name: "United Arab Emirates", flag: "🇦🇪", phoneCode: "+971" },
    { name: "United Kingdom", flag: "🇬🇧", phoneCode: "+44" },
    { name: "United States", flag: "🇺🇸", phoneCode: "+1" },
    { name: "Uruguay", flag: "🇺🇾", phoneCode: "+598" },
    { name: "Uzbekistan", flag: "🇺🇿", phoneCode: "+998" },
    { name: "Vanuatu", flag: "🇻🇺", phoneCode: "+678" },
    { name: "Vatican City", flag: "🇻🇦", phoneCode: "+379" },
    { name: "Venezuela", flag: "🇻🇪", phoneCode: "+58" },
    { name: "Vietnam", flag: "🇻🇳", phoneCode: "+84" },
    { name: "Yemen", flag: "🇾🇪", phoneCode: "+967" },
    { name: "Zambia", flag: "🇿🇲", phoneCode: "+260" },
    { name: "Zimbabwe", flag: "🇿🇼", phoneCode: "+263" }
  ];

  export default countryData;